<template>
  <DialogCard>
    <template #title>
      Scientists
    </template>
    <template #text>
      <p>
        Let us leverage  existing magnetic resonance images to accelerate research.
      </p>
      <ul>
        <li>
          The openVOXEL platform changes the paradigm of magnetic resonance imaging by putting
          researcher in control.
          This allows us to build a very large, community-driven database of magnetic resonance
          images that can enable important research projects and make a true impact.
        </li>
        <li>
          Many openVOXEL users are interested in actively contributing to ongoing research projects.
          We can help researchers in gathering complimentary data that are virtually impossible to
          obtain otherwise by automatically comparing their aggregated data to those of other
          researchers.
        </li>
        <li>
          We are committed to the highest scientific standards and strive to become the trusted
          source of information on data from magnetic resonance imaging.
        </li>
        <li>
          We seek partnerships with academic institutions and research groups that are
          dedicated to improving our understanding of the human brain. Interested?
          Send us a message to <a href="mailto:openvoxelorg@gmail.com">openvoxelorg@gmail.com</a>
          and we’ll get back to you.
        </li>
      </ul>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'OpenvoxelScientistsDialog',
  components: {
    DialogCard,
  },
};
</script>
